'use client';

import { motion } from 'framer-motion';
import { Box, Lock, Search, Settings, Sparkles } from 'lucide-react';

export function GlowingGridSection() {
  const gridItems = [
    {
      icon: Box,
      title: 'Do things the right way',
      description: 'Build with best practices and architectural excellence.',
      colSpan: 'col-span-1',
    },
    {
      icon: Settings,
      title: 'The best configuration ever',
      description: 'Zero-config setup with sensible defaults out of the box.',
      colSpan: 'col-span-1',
    },
    {
      icon: Lock,
      title: 'Enterprise Security',
      description: 'Built-in security features for peace of mind at scale.',
      colSpan: 'md:col-span-2',
    },
    {
      icon: Sparkles,
      title: 'Premium Components',
      description: 'Hand-crafted, battle-tested components ready to use.',
      colSpan: 'col-span-1',
    },
    {
      icon: Search,
      title: 'Search & Discovery',
      description: 'Powerful search and discovery features included.',
      colSpan: 'md:col-span-2',
    },
  ];

  return (
    <section className="relative w-full bg-gradient-to-b from-white to-slate-50 px-4 py-20 dark:from-slate-950 dark:to-slate-900 md:py-32">
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-4 text-4xl font-bold text-slate-900 dark:text-white md:text-5xl">
            Premium Features with Glow
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-slate-600 dark:text-slate-400">
            Interactive glowing cards that react to your cursor position
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {gridItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className={`group relative min-h-[200px] overflow-hidden rounded-2xl border border-slate-200 p-6 transition-all duration-300 hover:border-blue-500 dark:border-slate-700 dark:hover:border-blue-500 ${item.colSpan}`}
              >
                <div className="absolute -inset-0.5 rounded-2xl bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 opacity-0 blur-2xl transition-all duration-500 group-hover:opacity-30" />
                <div className="relative rounded-xl border border-slate-200 bg-white p-6 dark:border-slate-700 dark:bg-slate-800">
                  <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg border border-slate-300 bg-slate-50 text-slate-600 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-300">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="mb-2 text-lg font-bold text-slate-900 dark:text-white">{item.title}</h3>
                  <p className="text-sm text-slate-600 dark:text-slate-400">{item.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
